import { Component, computed, Signal } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { TooltipModule } from 'primeng/tooltip';
import { HelpDisplayService } from '../../services/help-display.service';

@Component({
  selector: 'app-help',
  imports: [ButtonModule, TooltipModule],
  templateUrl: './help.component.html'
})
export class HelpComponent {

  active: Signal<boolean>;

  constructor(private help: HelpDisplayService) {
    this.active = computed(() => this.help.id() >= 0);
  }

  showHelp() {
    if (this.help.visible()) return;
    this.help.show();
  }
}
